import React from 'react';
import { useMetaPixel } from './components/MetaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { SocialProof } from './components/SocialProof';
import { WhatsInside } from './components/WhatsInside';
import { ForWho } from './components/ForWho';
import { PricingCTA } from './components/PricingCTA';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-primary text-warm-white font-inter selection:bg-gold selection:text-primary" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Testimonials data-id="element-4" />
        <Problem data-id="element-5" />
        <Solution data-id="element-6" />
        <SocialProof data-id="element-7" />
        <WhatsInside data-id="element-8" />
        <ForWho data-id="element-9" />
        <PricingCTA data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}